export default __webpack_public_path__ + "static/media/login-slider@2x.dbbce699.png";